import React from "react";

export default function PhoneMockup({
  image,
  alt = "App screenshot",
  className = "",
  size = "default"
}) {
  const sizes = {
    small: { width: 180, padding: 8, radius: 28, innerRadius: 22 },
    default: { width: 240, padding: 10, radius: 36, innerRadius: 28 },
    large: { width: 280, padding: 12, radius: 44, innerRadius: 34 },
  };

  const s = sizes[size] || sizes.default;

  return (
    <div
      className={`phone-mockup ${className}`}
      style={{
        width: s.width,
        padding: s.padding,
        borderRadius: s.radius,
        background: "linear-gradient(180deg, #1a1a1a 0%, #0d0d0d 100%)",
        boxShadow: `
          0 50px 100px rgba(0, 0, 0, 0.25),
          inset 0 1px 0 rgba(255, 255, 255, 0.1),
          inset 0 -1px 0 rgba(0, 0, 0, 0.5)
        `,
      }}
    >
      <div
        className="phone-mockup-screen"
        style={{
          width: "100%",
          aspectRatio: "9 / 19.5",
          borderRadius: s.innerRadius,
          overflow: "hidden",
          background: "var(--color-bg-secondary)",
          position: "relative",
        }}
      >
        {image && (
          <img
            src={image}
            alt={alt}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "top center",
            }}
          />
        )}
        <div
          className="phone-mockup-notch"
          style={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: size === "small" ? 80 : size === "large" ? 120 : 100,
            height: size === "small" ? 24 : size === "large" ? 34 : 28,
            background: "#0d0d0d",
            borderRadius: "0 0 16px 16px",
          }}
        />
      </div>
    </div>
  );
}
